document.addEventListener('DOMContentLoaded', function() {
    const container_card = document.querySelectorAll('.container-card');

    // reccorer todas las card y cuando se le de click a una card y dar height dinamicamente al elemento description-card-ingredient que esta dentro del container card a su vez ocultar si hay una card abierta o ocultar si esta abierto el mismo card y coloca una class active al elemento que se le da click

    container_card.forEach((card) => {
        card.addEventListener('click', () => {
            const description_card_ingredient = card.querySelector('.description-card-ingredient');
            const container_card_active = document.querySelector('.container-card.active');

            if (card.classList.contains('active')) {
                card.classList.remove('active');
                description_card_ingredient.style.height = '0';
            } else {
                card.classList.add('active');
                description_card_ingredient.style.height = description_card_ingredient.scrollHeight + 20 + 'px';
            }

            if (container_card_active) {
                container_card_active.classList.remove('active');
                container_card_active.querySelector('.description-card-ingredient').style.height = '0';
            }


        });
    });
    
});